import React from 'react';
import styled from 'styled-components';

const CircularProgressSvg = styled.svg`
  width: 24px;
  height: 24px;
`;

const RotatingGroup = styled.g`
  animation: spin 1s linear infinite;
  transform-origin: center;

  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

const CircularProgressBackground = styled.circle`
  fill: none;
  stroke: ${(props) => props.theme.colors.NEUTRAL_40};
  stroke-width: 3;
`;

const CircularProgressIndicator = styled.circle`
  fill: none;
  stroke: ${(props) => props.theme.colors.NEUTRAL_0};
  stroke-width: 3;
  stroke-linecap: round;
  stroke-dasharray: 62.83; /* Circumference for radius 10 */
  stroke-dashoffset: ${(props) => 62.83 * (1 - props.value / 100)};
  transition: stroke-dashoffset 0.3s ease;
`;

const ProgressText = styled.text`
  fill: ${(props) => props.theme.colors.NEUTRAL_40};
  font-size: 8px;
  font-weight: 500;
  text-anchor: middle;
  dominant-baseline: middle;
`;

const CircularProgress = ({ value = 0, size = 24, showValue = true, ...props }) => {
  return (
    <CircularProgressSvg viewBox="0 0 24 24" width={size} height={size} {...props}>
      <RotatingGroup>
        <CircularProgressBackground cx="12" cy="12" r="10" />
        <CircularProgressIndicator cx="12" cy="12" r="10" value={value} />
      </RotatingGroup>
      {showValue && (
        <ProgressText x="12" y="12">
          {Math.round(value)}%
        </ProgressText>
      )}
    </CircularProgressSvg>
  );
};

export default CircularProgress;